/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  BulkMarkAsReadRequestRequest,
  BulkMarkAsReadResponse,
  MarkAllAsReadResponse,
  Notification,
  NotificationRequest,
  NotificationsListParams,
  PaginatedNotificationList
} from '../models';

import { customInstance } from '.././custom-instance';
import type { ErrorType } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const notificationsList = (
    params?: NotificationsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedNotificationList>(
      {url: `/all/notifications/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getNotificationsListQueryKey = (params?: NotificationsListParams,) => {
    return [
    `/all/notifications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getNotificationsListQueryOptions = <TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorType<ApiError>>(params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsList>>> = ({ signal }) => notificationsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsList>>>
export type NotificationsListQueryError = ErrorType<ApiError>


export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorType<ApiError>>(
 params: undefined |  NotificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorType<ApiError>>(
 params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorType<ApiError>>(
 params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsList<TData = Awaited<ReturnType<typeof notificationsList>>, TError = ErrorType<ApiError>>(
 params?: NotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const notificationsCreate = (
    notificationRequest: NotificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Notification>(
      {url: `/all/notifications/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationRequest, signal
    },
      options);
    }




export const getNotificationsCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsCreate>>, TError,{data: NotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsCreate>>, TError,{data: NotificationRequest}, TContext> => {

const mutationKey = ['notificationsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsCreate>>, {data: NotificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  notificationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsCreate>>>
    export type NotificationsCreateMutationBody = NotificationRequest
    export type NotificationsCreateMutationError = ErrorType<ApiError>

    export const useNotificationsCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsCreate>>, TError,{data: NotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsCreate>>,
        TError,
        {data: NotificationRequest},
        TContext
      > => {
      return useMutation(getNotificationsCreateMutationOptions(options), queryClient);
    }
    export const notificationsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Notification>(
      {url: `/all/notifications/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getNotificationsRetrieveQueryKey = (id: number,) => {
    return [
    `/all/notifications/${id}/`
    ] as const;
    }


export const getNotificationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof notificationsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsRetrieve>>> = ({ signal }) => notificationsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsRetrieve>>>
export type NotificationsRetrieveQueryError = ErrorType<ApiError>


export function useNotificationsRetrieve<TData = Awaited<ReturnType<typeof notificationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsRetrieve<TData = Awaited<ReturnType<typeof notificationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsRetrieve<TData = Awaited<ReturnType<typeof notificationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsRetrieve<TData = Awaited<ReturnType<typeof notificationsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const notificationsMarkAsReadCreate = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Notification>(
      {url: `/all/notifications/${id}/mark_as_read/`, method: 'POST', signal
    },
      options);
    }




export const getNotificationsMarkAsReadCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAsReadCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAsReadCreate>>, TError,{id: number}, TContext> => {

const mutationKey = ['notificationsMarkAsReadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsMarkAsReadCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  notificationsMarkAsReadCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsMarkAsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsMarkAsReadCreate>>>

    export type NotificationsMarkAsReadCreateMutationError = ErrorType<ApiError>

    export const useNotificationsMarkAsReadCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAsReadCreate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsMarkAsReadCreate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getNotificationsMarkAsReadCreateMutationOptions(options), queryClient);
    }
    /**
 * Mark multiple specific notifications as read.
 * Request body: {"notification_ids": [1, 2, 3, ...]}
 */
export const notificationsBulkMarkAsReadCreate = (
    bulkMarkAsReadRequestRequest: BulkMarkAsReadRequestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<BulkMarkAsReadResponse>(
      {url: `/all/notifications/bulk-mark-as-read/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkMarkAsReadRequestRequest, signal
    },
      options);
    }




export const getNotificationsBulkMarkAsReadCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsBulkMarkAsReadCreate>>, TError,{data: BulkMarkAsReadRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsBulkMarkAsReadCreate>>, TError,{data: BulkMarkAsReadRequestRequest}, TContext> => {

const mutationKey = ['notificationsBulkMarkAsReadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsBulkMarkAsReadCreate>>, {data: BulkMarkAsReadRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  notificationsBulkMarkAsReadCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsBulkMarkAsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsBulkMarkAsReadCreate>>>
    export type NotificationsBulkMarkAsReadCreateMutationBody = BulkMarkAsReadRequestRequest
    export type NotificationsBulkMarkAsReadCreateMutationError = ErrorType<ApiError>

    export const useNotificationsBulkMarkAsReadCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsBulkMarkAsReadCreate>>, TError,{data: BulkMarkAsReadRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsBulkMarkAsReadCreate>>,
        TError,
        {data: BulkMarkAsReadRequestRequest},
        TContext
      > => {
      return useMutation(getNotificationsBulkMarkAsReadCreateMutationOptions(options), queryClient);
    }
    export const notificationsMarkAllAsReadCreate = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MarkAllAsReadResponse>(
      {url: `/all/notifications/mark-all-as-read/`, method: 'POST', signal
    },
      options);
    }




export const getNotificationsMarkAllAsReadCreateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAllAsReadCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAllAsReadCreate>>, TError,void, TContext> => {

const mutationKey = ['notificationsMarkAllAsReadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsMarkAllAsReadCreate>>, void> = () => {


          return  notificationsMarkAllAsReadCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsMarkAllAsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsMarkAllAsReadCreate>>>

    export type NotificationsMarkAllAsReadCreateMutationError = ErrorType<ApiError>

    export const useNotificationsMarkAllAsReadCreate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAllAsReadCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsMarkAllAsReadCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getNotificationsMarkAllAsReadCreateMutationOptions(options), queryClient);
    }
